import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FEATURE_FLAGS } from "@/config/featureFlags";
import type { ChatDomain } from "@/domains/chat/types";
import { DomainChatModal } from "./DomainChatModal";
import { JerryButton } from "@/components/ui/JerryButton";

interface DomainChatTriggerProps {
  domain: ChatDomain;
}

export const DomainChatTrigger = ({ domain }: DomainChatTriggerProps) => {
  const { t } = useTranslation("installments");
  const [isOpen, setIsOpen] = useState(false);

  if (!FEATURE_FLAGS.domainChat) return null;

  return (
    <>
      <JerryButton onClick={() => setIsOpen(true)}>{t("chat.trigger")}</JerryButton>
      <DomainChatModal domain={domain} isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
